import { initializeApp } from 'firebase/app'
import { getAnalytics, setUserProperties, setUserId, logEvent, type Analytics } from 'firebase/analytics'
import firebaseConfig from './firebaseConfig'

const app = initializeApp(firebaseConfig)
const webAnalytics: Analytics = getAnalytics(app)

export async function sendFBAnalyticsEvent(event: string, params: Record<string, unknown> = {}): Promise<void> {
  try {
    // Cast to string to allow custom event names
    logEvent(webAnalytics, event as 'login', params)
  } catch (error: unknown) {
    console.log(error)
  }
}

export async function setFBAnalyticsUserId(uid: string): Promise<void> {
  try {
    setUserId(webAnalytics, uid)
  } catch (error: unknown) {
    console.log(error)
  }
}

export async function setFBAnalyticsUserProperties(properties: Record<string, string>): Promise<void> {
  try {
    setUserProperties(webAnalytics, properties)
  } catch (error: unknown) {
    console.log(error)
  }
}

export async function logFBAnalyticsScreenView(screen: { screen_name: string; screen_class?: string }): Promise<void> {
  try {
    // Firebase web SDK uses 'screen_view' as a custom event
    logEvent(webAnalytics, 'screen_view' as 'login', screen)
  } catch (error: unknown) {
    console.log(error)
  }
}
